module.exports = __webpack_public_path__ + "static/media/0013-Erkundigen_mV_ID_12.d77a51f6.mp3";